module.exports = __webpack_public_path__ + "static/img/loginWeiTu3.29ec054.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/login2/loginWeiTu3.png
// module id = aHuo
// module chunks = 1